import { Injectable, signal } from '@angular/core';

export const DEFAULT_HEADER_NAME = 'NextGen testOFFICE';

@Injectable({ providedIn: 'root' })
export class HeaderNameService {
  readonly name = signal<string>(DEFAULT_HEADER_NAME);

  loadFromBackend(backendName?: string): void {
    this.name.set(backendName?.trim() ? backendName : DEFAULT_HEADER_NAME);
  }
}
